// const BASE_URL = 'https://testing1.tunga.io';
const BASE_URL = process.env.REACT_APP_BACKEND_ROOT;
export const ACADEMY_URL = 'https://academy.tunga.io/resources/';
export default BASE_URL;
